import React from 'react';
import { Navigate } from 'react-router-dom';
import { estAdministrateur } from '../utils/auth';

interface RouteAdminPilotageProps {
  children: React.ReactNode;
}

const RouteAdminPilotage = ({ children }: RouteAdminPilotageProps) => {
  const accessToken = localStorage.getItem('accessToken');

  if (!accessToken) {
    return <Navigate to="/" replace />;
  }

  if (!estAdministrateur()) {
    return <Navigate to="/acces-refuse-pilotage" replace state={{ depuis: window.location.pathname }} />;
  }

  return children;
};

export default RouteAdminPilotage;
